import { Suspense } from "react";
import { Element, MDXProps, MDXComponents } from "mdx/types";
import cn from "classnames";
import { CommonPage } from "./CommonPage";

type NotePageProps = {
  title: string;
  Content:
    | ((props: MDXProps) => Element)
    | React.LazyExoticComponent<(props: MDXProps) => Element>;
  components?: MDXComponents;
};

export const CommonNotePage: React.FC<NotePageProps> = ({
  title,
  Content,
  components,
}) => {
  return (
    <CommonPage>
      <title>{title}</title>
      <article
        className={cn(
          "prose prose-slate md:prose-lg lg:prose-xl dark:prose-invert max-w-none",
          "prose-a:text-green-800 dark:prose-a:text-green-300"
        )}
      >
        <Suspense>
          <Content components={components} />
        </Suspense>
      </article>
    </CommonPage>
  );
};
